export enum DayOfWeek {
  Mon = 'Mon',
  Tue = 'Tue',
  Wed = 'Wed',
  Thu = 'Thu',
  Fri = 'Fri',
  Sat = 'Sat',
  Sun = 'Sun',
}

export const DayOfWeekLabel = {
  [DayOfWeek.Mon]: 'shared.days.monday',
  [DayOfWeek.Tue]: 'shared.days.tuesday',
  [DayOfWeek.Wed]: 'shared.days.wednesday',
  [DayOfWeek.Thu]: 'shared.days.thursday',
  [DayOfWeek.Fri]: 'shared.days.friday',
  [DayOfWeek.Sat]: 'shared.days.saturday',
  [DayOfWeek.Sun]: 'shared.days.sunday',
};
